import React from 'react';
import '../assets/css/componentStyles/SettingsSectionHeader.css';

function SettingsSectionHeader({
  header,
  headerClassName,
  description,
  variant = 'primary',
  helpButton,
  className = '',
  id,
}) {
  const getVariantClass = () => {
    switch (variant) {
      case 'secondary':
        return 'settings-section-header--secondary';
      case 'noBorder':
        return 'settings-section-header--no-border';
      default:
        return '';
    }
  };

  const headerClasses = `settings-section-header ${getVariantClass()} ${className}`;

  return (
    <div className={headerClasses} id={id}>
      <div className="settings-section-header-content">
        <div className="settings-section-header-text">
          <h2 className={`settings-section-header-title ${headerClassName || ''}`}>
            {header}
            {helpButton && <span className="header-help-button">{helpButton}</span>}
          </h2>
          {description && <p className="settings-section-header-description">{description}</p>}
        </div>
      </div>
    </div>
  );
}

export default SettingsSectionHeader;
